export enum RankingPeriod {
  CURRENT_MONTH = "current-month",
  PREVIOUS_MONTH = "previous-month",
  PERMANENT = "permanent",
}